import { computed, getCurrentInstance } from 'vue';
import { getCardStatus } from '@/utilities/defaultCardStatuses';
import { Card } from '@superthread-com/api';
import { getSprintListKey } from '@/utilities/sprintKeys';
import constants from '@/utilities/constants';
import cardStatusType from '@/types/cardStatusType';

export default function useCardStatus(
  cardId: string,
  fallbackCard: any = {},
  defaultIcon: string = getCardStatus(cardStatusType.Backlog).icon,
  defaultColor: string = getCardStatus(cardStatusType.Backlog).color
) {
  const _this = getCurrentInstance()?.proxy as any;
  if (!_this) return;

  const stateCard = computed(() => {
    // avoid using getCardById, if cardId is undefined, it will return the current card
    return (_this.$store.getters.getCards[cardId] ?? {}) as Card;
  });

  const card = computed(() => {
    return stateCard.value.id ? stateCard.value : fallbackCard;
  });

  const flatLists = computed<any>(() => {
    return _this.$store.getters.lists ?? {};
  });

  const cardListId = computed<string>(() => {
    return card.value.sprint_id
      ? getSprintListKey(card.value.project_id, card.value.sprint_id, card.value.list_id)
      : (card.value.list_id ?? '');
  });

  const cardList = computed<any>(() => {
    return flatLists.value[cardListId.value] ?? {};
  });

  const statusSource = computed<any>(() => {
    return (
      getCardStatus(card.value.status, isEpic.value) ||
      (Object.keys(cardList.value).length ? cardList.value : null) ||
      {}
    );
  });

  const cardStatus = computed<any>(() => {
    const color =
      statusSource.value.color ||
      getCardStatus(cardList.value.behavior, isEpic.value)?.color ||
      defaultColor;
    const icon =
      getCardStatus(cardList.value.behavior, isEpic.value)?.icon ||
      statusSource.value.icon ||
      defaultIcon;

    return {
      color,
      icon,
    };
  });

  const isEpic = computed<boolean>(() => {
    return card.value.board_id === constants.epicsBoardId;
  });

  return {
    cardStatus,
  };
}
